import { Link } from "react-router-dom";
import { H5, Image, P } from "../../../../AbstractElements";
import { Href, PainterTour, PainterTourSpan, PainterTourTitle, ReadMore, WilliamJennings, WonderfulTour } from "../../../../Constants/Constants";
import { dynamicImage } from "../../../../Utils";

export const SecondStyleAboutSection = () => {
  return (
    <>
      <H5 className="pb-3">{WonderfulTour}</H5>
      <P className="block-ellipsis">
        {PainterTourTitle}
        <em className="text-danger">{WilliamJennings}</em>
        {PainterTour}
      </P>
      <div className="img-container">
        <div id="aniimated-thumbnials">
          <Link to={Href}>
            <Image className="img-fluid rounded" src={dynamicImage(`other-images/profile-style-img3.png`)} alt="gallery" />
          </Link>
          <P className="block-ellipsis pt-3">
            {PainterTourSpan}
            <Link className="text-danger ms-1" to={`${process.env.PUBLIC_URL}/applications/users/user_profile`}>
              {ReadMore}
            </Link>
          </P>
        </div>
      </div>
    </>
  );
};
